// /******************************** Import Package ************************************/
// import React from "react";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemText from "@material-ui/core/ListItemText";
// import { Link } from "react-router-dom";
// import { makeStyles } from "@material-ui/core/styles";
// import "./SideNavigation.css";
// import { useLocation } from "react-router-dom"

// /******************************** SideNavigation Stye ************************************/
// const useStyles = makeStyles((theme) => ({
//   navigate: {
//     textDecoration: "none",
//     color: "white",
//     background: "#4e9a98",

//   },
//   sideNav: {
//     background: "#4e9a98",
//     "&:hover": {
//       background: "#9acad6 ",
//     },
//   },
//   icon: {
//     color: "white",
//   },
// }));

// /******************************** SideNavigation  ************************************/
// const SideNavigate = ({ link, name, icon ,open}) => {
//   const classes = useStyles();
//   const location = useLocation();
//   return (
//     <Link className={ classes.navigate } to={ `/${link}` }>
//       <ListItem button className={ classes.sideNav }
//        style={ `${location.pathname}` === `/${link}` ? { background: "#9acad6 " } : { background: "" } } >
//         <ListItemIcon className={ `${classes.icon} tool-tip` }>{icon} <span className="tool-tip-text">{name}</span></ListItemIcon>
//         <ListItemText className={`${open?"sideMenu":null}`} primary={ name } />
//       </ListItem>
//     </Link>
//   );
// };

// export default SideNavigate;

/******************************** Import Package ************************************/
import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import "./SideNavigation.css";

/******************************** SideNavigation Style ************************************/
const NavigateLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: "white",
  width: "100%",
}));

const SideNav = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
  background: active ? "#9acad6" : "#4e9a98",
  paddingLeft: "18px",
  paddingRight: "12px",
  minHeight: 48,
  transition: "all 0.3s ease",
  "&:hover": {
    background: "#9acad6",
  },
}));

const IconStyled = styled(ListItemIcon)(() => ({
  color: "white",
  minWidth: 52,
  display: "flex",
  justifyContent: "flex-start",
}));

const TextStyled = styled(ListItemText)(() => ({
  color: "white",
  fontSize: "14px",
  fontWeight: 500,
  textWrap: "wrap",
  paddingLeft: "4px",
}));

/******************************** SideNavigation  ************************************/
const SideNavigate = ({ link, name, icon, open }) => {
  const location = useLocation();
  const isActive = location.pathname === `/${link}`;

  return (
    <NavigateLink to={`/${link}`} className="navigate">
      <SideNav button active={isActive ? 1 : 0}   >

        <IconStyled className="tool-tip" >
          {icon}
          {!open && <span className="tool-tip-text">{name}</span>}
        </IconStyled>

        {/* Show text only if sidebar is open */}
        {open && <TextStyled primary={name} />}
      </SideNav>
    </NavigateLink>
  );
};

export default SideNavigate;
